<script lang="ts">
    export let direction = "right";
    export let isPaused = false;
    export let rootElement;
    let flipsvg = false;

    if (direction == "left") {
      flipsvg = true;
    }
</script>

<style lang="scss">
  * {
    .shapes > * {
    opacity: 0;
    animation-duration: 3.5s;
    animation-iteration-count: infinite;
    animation-timing-function: steps(1);
  }
  @keyframes tri-dipreach-1 {
    0%,
    12.5% {
      opacity: 1;
    }
    12.5%,
    50% {
      opacity: 0;
    }
    50%,
    62.5% {
      opacity: 1;
    }
    62.5%,
    100% {
      opacity: 0;
    }
  }
  #tri-dipreach-1 {
    animation-name: tri-dipreach-1;
  }
  @keyframes tri-dipreach-2 {
    0%,
    12.5% {
      opacity: 0;
    }
    12.5%,
    25% {
      opacity: 1;
    }
    25%,
    37.5% {
      opacity: 0;
    }
    37.5%,
    50% {
      opacity: 1;
    }
    50%,
    62.5% {
      opacity: 0;
    }
    62.5%,
    75% {
      opacity: 1;
    }
    75%,
    87.5% {
      opacity: 0;
    }
    87.5%,
    100% {
      opacity: 1;
    }
  }
  #tri-dipreach-2 {
    animation-name: tri-dipreach-2;
  }
  @keyframes tri-dipreach-3 {
    0%,
    25% {
      opacity: 0;
    }
    25%,
    37.5% {
      opacity: 1;
    }
    37.5%,
    100% {
      opacity: 0;
    }
  }
  #tri-dipreach-3 {
    animation-name: tri-dipreach-3;
  }
  @keyframes tri-dipreach-4 {
    0%,
    75% {
      opacity: 0;
    }
    75%,
    87.5% {
      opacity: 1;
    }
    87.5%,
    100% {
      opacity: 0;
    }
  }
  #tri-dipreach-4 {
    animation-name: tri-dipreach-4;
  }

  .paused .shapes > * {
    filter: grayscale(100%);
      opacity: 0.8;
      animation-play-state: paused;
    }
  
  .flip .shapes > *{
    transform-origin: center center;
    transform: scaleX(-1); }

}
</style>

<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 429.8 311.6" height="100%" width="100%">>
<g class:paused={isPaused} class:flip={flipsvg}>
  <g class="shapes" bind:this={rootElement}>
    <g id="tri-dipreach-1">
      <path
        fill="var(--cool500)"
        d="m121 198-8 2c-2 0-2 1-1 3l6 13 3 2 4-1a2 2 0 0 0 1-2l-3-15c0-1 0-2-2-2Zm36 45-7 5c-2 1-3 4-2 6l7 30c2 4 0 6-5 5l-2-2-10-26c-1-4-3-5-7-5l-34-4-43-4c-3-1-3 1-3 3l-2 20c0 3-5 5-7 4l-1-3 2-34 2-22-2-7c-1-1-2-2 0-3s1-2 0-3l-16-34-25-50c-1-3-1-3 2-3l59 4c3 1 4 2 5 4 6 7 10 16 15 25l20 38c1 1 2 2 3 1l18-3a2 2 0 0 1 2 1l3 10c4 10 11 20 14 31l2 2c5 2 8 4 8 10 0 2 1 3 4 4Zm-93-1-9-20-2 16c0 1-1 2 1 2l10 2Zm48 4h1l16 2c4 1 4 1 3-3 0-1 0-3-2-3l-18 4Z"
      />
      <path
        fill="var(--shirt)"
        d="m176 239-4-9-4-13-3-9a3 3 0 0 0 0-1l-4-22c0-1 0-2-2-1h-2a6 6 0 0 0 0-2l-6-20c5-5 12-8 18-10l14-6c5 2 9 4 11 8 1 3 2 5 5 7 2-5 2-5 5-5 6 11 5 22 4 33-1 4 2 6 2 9 1 5 4 9 6 14l2 2c3 1 3 3 3 5 1 3 0 5-3 5-6 0-11 2-16 6l-16 15-3 2c-1 1-1 2-3-1l-4-7Z"
      />
      <path
        fill="var(--flesh)"
        d="M359 304c-3-3-7-3-10-4l-27-2c-10-1-20-3-29-7l-20-11c-7-4-14-8-23-7l-1-1 3-3c4-5 7-10 9-16 0-2 1-4-2-5-2-1-1-2-1-3a28 28 0 0 1 6-6c1 2 3 2 5 3l13 2a19 19 0 0 1 10 5c6 5 12 8 20 8l35 5a45 45 0 0 0 6 0 17 17 0 0 0 2 1c5 1 6 4 2 8a16 16 0 0 1-14 6l-22-1a15 15 0 0 0 2 2 155 155 0 0 0 24 8c3 0 6 2 10 0a2 2 0 0 0 2 0l3 1 1 6c1 3 2 4 6 2h2c2 1 3 3 3 5s-2 4-4 4a13 13 0 0 1-7 0 16 16 0 0 0-4 0Z"
      />
      <path
        fill="var(--pants)"
        d="M264 239a28 28 0 0 0-6 6c0 1-1 2 1 3 3 1 2 3 2 5-2 6-5 11-9 16l-3 3a52 52 0 0 1-9 8c-3 2-6 2-8-1-5-7-13-9-21-10-11-1-19-6-24-15 0-3-2-6-1-9l16-15c5-4 10-5 16-6 3 0 4-2 3-5h5c2 0 4 0 5 2 2 4 7 5 11 6a147 147 0 0 1 21 10l1 2Z"
      />
      <path
        fill="var(--flesh)"
        d="m151 162 6 20a6 6 0 0 1 0 2c-5 1-9 3-14 3-2 0-4 1-3 4l8 20c1 7 3 9 9 11 3 2 6 3 6 8 1 3 0 5-1 8-2 2-3 4-6 4-2 0-3-1-3-3 0-6-3-8-8-10l-2-2c-3-11-10-21-14-31l-3-10a2 2 0 0 0-2-1c0-5 2-8 5-10a174 174 0 0 1 22-13Z"
      />
      <path
        fill="var(--hair)"
        d="M359 304a16 16 0 0 1 4 0 13 13 0 0 0 7 0c2 0 3-1 4-4s-1-4-3-5h-2c-4 2-5 1-6-2l-1-6c0-1 0-2 2-2 6 0 11-3 16-6l15-12c2-2 4-5 7-3s4 4 4 7c1 13-4 22-14 29l-11 8c-7 5-15 2-21-2a2 2 0 0 1-1-2Z"
      />
      <path
        fill="var(--flesh)"
        d="M204 156c-3 0-3 0-5 5-3-2-4-4-5-7-3-4-6-6-11-8v-2c2-1 3-3 3-5l1-6a4 4 0 0 1 4-3c2 0 3 1 3 3a43 43 0 0 1 1 5l1 2a2 2 0 0 0 2-2v-3c0-2 1-5 3-6 2-2 2-4 1-6-1-3 0-4 3-4a10 10 0 0 1 7 2c0 4 2 7 1 12-1 1 1 2 2 3 1 2 2 4-1 5v2c0 2 0 4-2 6 0 5-4 5-8 7Z"
      />
      <path
        fill="var(--hair)"
        d="M212 121a10 10 0 0 0-7-2c-3 0-4 2-3 4s1 4-1 6c-2 1-3 4-3 6v4a2 2 0 0 1-2 1l-1-2a43 43 0 0 0-1-5c0-2-1-3-3-3a4 4 0 0 0-4 3l-1 6c0 2-1 4-3 5a40 40 0 0 1-6-23c0-5 5-10 10-11 7-1 14 1 21 2h4c4 1 5 3 3 5a30 30 0 0 1-3 4ZM359 286a2 2 0 0 1-2 0l-16-9h2a16 16 0 0 0 14-6c4-4 3-7-2-8a17 17 0 0 1-2-1c-1-1 0-1 1-1 9 1 16-3 22-10 2-2 3-4 6-4s5 0 4 3c0 6-1 12-6 16l-21 20Z"
      />
      <path
        fill="var(--cool500)"
        d="m162 238 2-8c-1-5-4-6-7-8-6-2-8-4-9-11l17-3 3 9 4 13ZM186 245c-1 3 1 6 1 9-6 0-6 0-7-5l-4-10 4 7c1 3 2 2 3 1s1-2 3-2Z"
      />
    </g>
    <g id="tri-dipreach-2">
      <path
        fill="var(--cool500)"
        d="m157 242-8 7a4 4 0 0 0-2 5l8 30c1 3-1 4-2 5s-5 0-6-2l-11-28a4 4 0 0 0-4-3l-59-6-19-2c-2 0-3 0-3 3l-2 21a3 3 0 0 1-2 2l-6 1v-2l2-30 2-27-2-7-1-2c3-1 1-3 1-4L3 121l-2-3v-1l29 2 30 2c4 1 7 2 9 6 10 15 18 31 27 47l7 14c1 1 1 2 3 1l41-8-1 6-13 2c-2 0-3 1-2 3l5 18c1 4 1 4 5 4l4-1v9c-1 3 1 5 3 7 5 2 8 5 7 11l2 2Zm-31-26-3-16c0-2-1-1-2-1l-9 2c-2 0-1 1-1 2l7 13c1 2 7 2 8 1a3 3 0 0 0 0-1Zm-71 7h-1l-1 16v2l11 1-9-19Zm57 23v1l19 2 1-1a17 17 0 0 0-1-5h-3l-16 3Z"
      />
      <path
        d="M190 111c5 3 9 5 13 9 6 5 9 12 11 19 2 5 6 8 9 12l5 4c3 3 7 5 9 9a5 5 0 0 0 3 3 5 5 0 0 1 4 4 9 9 0 0 1-5 2 37 37 0 0 0-17 10c-6 5-10 12-14 19v3c-3 2-3 2-6-1l-15-17h-1c-3-4-5-8-9-11l-8-13c1-2 1-3-1-4a68 68 0 0 0-12-8c-2-1-4 0-6-2 1-8 0-17 3-25a17 17 0 0 1 5-7l11-9c8-3 14 0 21 3Z"
        fill="var(--shirt)"
      />
      <path
        fill="var(--flesh)"
        d="M289 209c4 4 8 8 14 11 3 1 5 4 7 7a26 26 0 0 0 7 6l19 11a108 108 0 0 0 22 10 14 14 0 0 0 3 1c0 2 2 2 3 2 1 1 3 0 3 2a7 7 0 0 1-6 8h-7l-9-4h-4a117 117 0 0 0 13 9c1 1 2 2 3 1a28 28 0 0 0 11 6c3 2 6 2 9 2v5c0 5 1 5 6 4h2v6c-1 2-2 3-4 3a12 12 0 0 1-5-1l-6-2c-10-7-23-9-34-14-10-4-20-7-28-15l-14-12c-7-7-16-13-27-15a3 3 0 0 1 1-3c5-9 10-18 17-26 1-1 2-3 4-2Z"
      />
      <path
        d="M289 209c-2-1-3 1-4 2-7 8-12 17-17 26a3 3 0 0 0-1 3h-4a8 8 0 0 1-7-2 68 68 0 0 0-23-15c-9-4-18-10-25-18v-3c4-7 8-14 14-19a37 37 0 0 1 17-10 9 9 0 0 0 5-2l8 4a7 7 0 0 1 4 4 10 10 0 0 0 5 5c10 7 19 16 28 25Z"
        fill="var(--pants)"
      />
      <path
        fill="var(--flesh)"
        d="M150 149c2 2 4 1 6 2a68 68 0 0 1 12 8c2 1 2 2 1 4l-6 15-2 6v2l-6 24v6c0 2 1 3 3 4 5 2 9 4 9 11l-1 4a44 44 0 0 1-9 7l-2-2c1-6-2-9-7-11-2-2-4-4-3-7v-9a5 5 0 0 0 0-3l1-13v-10l1-6a13 13 0 0 1 1-4c3-7 1-15 1-22l1-6Z"
      />
      <path
        fill="var(--hair)"
        d="m370 296 6 2a12 12 0 0 0 5 1c2 0 4-1 4-3v-6h-2c-5 1-6 0-6-5v-4c1-1 1-3 2-2 3 2 6 0 8 0 7 0 13-2 18-5l8-4 2-2c6-3 10 0 9 6-1 11-6 20-17 25l-17 6c-7 3-16-1-19-7a3 3 0 0 1-1-2Z"
      />
      <path
        fill="var(--flesh)"
        d="M190 111c-7-3-13-6-21-3l-1-4c2-2 3-4 2-7a11 11 0 0 1-1-6c0-2 0-4 3-4a5 5 0 0 1 5 2 43 43 0 0 1 2 5l1 1 1-2-1-7a4 4 0 0 1 1-4c3-3 3-3 0-5a3 3 0 0 1-2-4l3-2h3c3-1 5 1 8 1l2 8v2c0 3 1 5 3 6 2 2 3 3 1 5l-1 2v10c1 2-1 3-3 4l-5 2Z"
      />
      <path
        fill="var(--hair)"
        d="M193 72c-3 0-5-2-8-1h-3l-3 2a3 3 0 0 0 2 4c3 2 3 2 0 5a4 4 0 0 0-1 4l1 7-1 2-1-1a43 43 0 0 0-2-5 5 5 0 0 0-5-2c-3 0-3 2-3 4a11 11 0 0 0 0 6c2 3 1 5-1 7l-3-3a48 48 0 0 1-7-13c-4-9 0-18 10-23a28 28 0 0 1 9-2 68 68 0 0 0 10-2c7-1 9 1 7 7l-1 4Z"
      />
      <path
        fill="var(--cool500)"
        d="m166 235 1-4c0-7-4-9-9-11-2-1-3-2-3-4v-6l10-2 1-2-4-21-1-1 2-6c3-1 4 0 5 3l5 16-1 10c0 3 1 5 4 7 1 1 3 2 2 4-2 3-1 4 1 5l7 27c0 2 0 4-2 4s-3 0-4-2l-7-19c-1-2-2-2-3-1a35 35 0 0 1-4 3Z"
      />
      <path
        fill="var(--hair)"
        d="M354 267h7a7 7 0 0 0 6-8c0-2-2-1-3-2-1 0-3 0-3-2 10 1 17-3 24-9 2-2 3-4 6-4 2-1 4 0 4 3-1 6-2 12-7 17l-19 16a6 6 0 0 1-1 1 28 28 0 0 1-11-6l-3-6Z"
      />
      <path
        fill="var(--flesh)"
        d="M179 223c-2-1-3-2-1-5 1-2-1-3-2-4-3-2-4-4-4-7l1-10 4-21c4 3 6 7 9 11l-5 13c-2 4-1 6 3 8a7 7 0 0 1 0 12c-1 1-3 3-5 3Z"
      />
    </g>
    <g id="tri-dipreach-3">
      <path
        fill="var(--cool500)"
        d="m185 224 6 26c1 1 1 3-1 4-2 0-4 0-5-3l-7-19a1043 1043 0 0 1-25 17 3 3 0 0 0-2 5l8 30c1 4-1 7-5 6l-2-2-11-28c-1-2-3-4-6-4l-27-3-48-4-7-1c-1 0-2 0-2 2l-2 21c0 3-5 6-7 4-2 0-1-1-1-2l3-50c1-5 2-11-2-16l1-1c2-1 1-3 0-4L1 117c-2-3-1-3 1-3l29 2 32 2a7 7 0 0 1 6 4l22 38 14 26a3 3 0 0 0 4 2l58-12h4v1l-1 6c0 4 1 7-1 10l-1-9c-1-2-2-2-4-2l-28 5c-2 1-2 2-2 4l5 16c1 7 1 7 8 5l21-4 1 4c1 4 4 5 9 6 3 0 5 1 5 5l-1 2c2 1 2-1 3-1Zm-60-27-10 2c-2 1-2 2-1 3l6 11c2 5 2 5 7 3h1a2 2 0 0 0 1-2l-3-16-1-1Zm-60 45-10-20a4882 4882 0 0 0-1 19Zm49 4a6 6 0 0 0 3 1l16 1h2a15 15 0 0 0 0-5l-3-1-18 4Z"
      />
      <path
        fill="var(--shirt)"
        d="M238 76c2 1 3 2 2 4-5 11-1 20 3 30l14 22 9 12a28 28 0 0 0 4 3v3h-3a71 71 0 0 0-11 8c-4 3-5 7-4 11a5 5 0 0 1-2 5 23 23 0 0 0-3 4l-3 6c-3 4-3 4-7 0a7 7 0 0 1-1-1 22 22 0 0 0-9-10c-6-4-10-9-15-14-2-4-6-6-9-9-2-2-5-1-7 1a6 6 0 0 0-1 3c0 3-1 5-5 4-5 0-10-2-15-1-2-3-1-6 0-9a20 20 0 0 0 1-11 12 12 0 0 1 2-10c4-5 7-10 7-17 0-3 3-1 4-2 3 0 5-1 6-4l3-6c4-2 6-7 10-9a2 2 0 0 0 1-2v-1a145 145 0 0 0 12-13l6-9c2 0 3 1 3 2l4 9c1 1 2 3 4 1Z"
      />
      <path
        fill="var(--pants)"
        d="m244 184 3-6a23 23 0 0 1 3-4 5 5 0 0 0 2-5c-1-4 0-8 4-11a71 71 0 0 1 11-8h3a75 75 0 0 1 11 11 4 4 0 0 0 3 2 6 6 0 0 1 5 3l28 34c1 1 2 2 1 3-4-6-6-6-11-2-5 3-8 7-12 11-2 3-4 5 0 8l-5 3c-3 2-4 1-5-2l-1-2-1 7a7 7 0 0 1-2 4h-3l-28-34a86 86 0 0 1-6-12Z"
      />
      <path
        fill="var(--flesh)"
        d="M295 220c-4-3-2-5 0-8 4-4 7-8 12-11 5-4 7-4 11 2l5 5 13 12 1 1c4 8 11 14 18 19l10 10c6 8 13 16 23 19l3 2c1 3 0 6 5 7l1 2c-1 3-4 5-8 4-4 0-8-2-12-1-1-3-3-4-5-5l-30-21a76 76 0 0 1-12-11 18 18 0 0 0-7-5 46 46 0 0 1-15-10l-13-11Z"
      />
      <path
        fill="var(--hair)"
        d="M377 283c4-1 8 1 12 1 4 1 7-1 8-5l-1-1c-5-1-4-4-5-7h3a23 23 0 0 0 20-2 70 70 0 0 1 8-4c2-1 4-1 6 1s2 4 1 6c-5 9-9 17-19 20l-12 6a16 16 0 0 1-8 1c-3 0-7-2-7-6l-5-8c0-1-2-1-1-2Z"
      />
      <path
        fill="var(--flesh)"
        d="M238 76c-2 2-3 0-4-1l-4-9c0-1-1-2-3-2 3-4 5-7 5-12-1-3 2-6 3-8l8-14v-9c-1-4-3-8-3-13l1-2 2 1 1-4c0-2 3-4 6-3a2 2 0 0 1 1 3 26 26 0 0 0 3 12v8l-6 28a25 25 0 0 1-3 10l-4 8-3 7ZM175 157c5-1 10 1 15 1a13 13 0 0 1-1 4c-3 7-5 13-6 20l-5 24c0 2 1 2 2 2h1c2 0 6 0 7 4 1 3 1 7-2 10l-1 2c-1 0-1 2-3 1l1-2c0-4-2-5-5-5-5-1-8-2-9-6l-1-4 1-15c2-3 1-6 1-10l1-6v-1c0-6 3-10 3-15a21 21 0 0 1 1-4Z"
      />
      <path
        fill="var(--hair)"
        d="M209 86v1c-1 2-2 1-2 0l-3-3-2-2-3 2a13 13 0 0 0 0 6c0 2-1 3-3 3a8 8 0 0 0-7 10h-1l-2-1c-6-4-8-10-7-17 0-6 10-12 16-10a30 30 0 0 1 14 11ZM365 250l-10-10c5 0 9-1 11-5a2 2 0 0 1 1-1c2-1 5-3 7-1s2 5 1 8c-2 4-5 7-10 9Z"
      />
      <path
        fill="var(--flesh)"
        d="M188 103s2 1 1-1a8 8 0 0 1 7-9c2 0 3-1 2-3a13 13 0 0 1 1-6l3-2 2 2 3 3c0 1 1 2 2 0a2 2 0 0 1-1 2c-4 2-6 7-10 9l-3 6c-1 3-3 4-6 4 0-2-2-3-1-5Z"
      />
    </g>
    <g id="tri-dipreach-4">
      <path
        fill="var(--cool500)"
        d="M193 250v-1l-7-27c-2-1-3-2-1-5 1-1-1-3-2-4-3-2-4-4-4-7l1-10-5-16a5 5 0 0 0-2-3 2 2 0 0 0-1-1l-3 1-59 11a3 3 0 0 1-3-2l-14-25-22-39a7 7 0 0 0-7-3l-31-2-29-2c-2-1-3 0-2 2l43 86c0 1 2 2-1 3v2c3 5 2 10 2 15l-3 50v3c3 1 8-1 8-4l2-22 2-2 7 1 48 5 27 3c3 0 4 1 5 4l11 28c1 1 1 2 3 2 4 0 6-2 5-6l-8-31a3 3 0 0 1 1-4l22-18c2-1 3-1 3 1l8 19c1 3 2 3 4 2 3 0 2-2 2-4Zm-137-9-2-2 2-17 10 21Zm61-41 9-2 2 1 3 16a2 2 0 0 1-1 2h-2c-4 1-4 1-7-3l-5-11c-1-2-1-3 1-3Zm20 49h-2l-16-1a6 6 0 0 1-3-1l18-4h2a14 14 0 0 1 1 6Zm12-36c-7 1-7 1-9-6l-4-15c-1-3 0-4 2-4l28-5c2-1 3 0 3 2l2 8 2 13c1 1 1 1-1 1l-10 2v1l-13 3Z"
      />
      <path
        fill="var(--flesh)"
        d="M203 131c-2 3-3 0-4-1l-4-8-3-3c2-3 27-52 27-57-1-3 2-6 3-8l8-14c2-3 1-5 1-8l-4-14 1-1c1-1 1 0 2 1l1-5c1-2 4-3 6-2a2 2 0 0 1 2 2 26 26 0 0 0 2 13v7l-5 28a25 25 0 0 1-4 10c-2 2-2 5-3 8l-26 52ZM153 172c5-1 10 1 15 1a13 13 0 0 1-1 5c-3 6-5 13-6 20l-5 23c0 2 1 3 2 3h1c3 0 6 0 7 3 2 4 1 7-2 10l-1 3h-2v-2c0-3-2-5-5-5-5 0-8-2-9-5 0-2 1-4-1-5l1-15c2-3 1-6 1-9l1-7v-1l3-15a21 21 0 0 1 1-4Z"
      />
      <path
        fill="var(--shirt)"
        d="M216 100c2 1 3 2 2 5-5 10-1 20 3 29l14 22c3 5 33 16 37 20 12 9-1 19-12 8-4 2-29 6-28 11 1 2-3 2-4 3a23 23 0 0 0-3 5c-1 2-4 3-3 6-3 3-3 3-7 0a6 6 0 0 1-1-2 22 22 0 0 0-9-9c-6-4-10-9-15-15l-9-9c-2-2-6-1-7 2a6 6 0 0 0-1 2c0 3-1 5-5 4-5 0-10-2-16-1v-8a20 20 0 0 0 2-12 12 12 0 0 1 2-9c4-5 7-11 7-17 0-3 3-2 4-3 3 1 5 0 6-3 1-2 1-5 3-6 4-2 6-7 10-9a2 2 0 0 0 0-2l1-2a146 146 0 0 0 11-13l7-9 3 3 4 8c1 1 2 4 4 1Z"
      />
      <path
        fill="var(--flesh)"
        d="M375 301c-2-4-6-5-9-6l-25-11c-9-4-18-8-26-14l-16-17c-5-5-11-11-19-13l-2-1 4-2c5-4 10-7 13-13 1-2 2-3 0-5v-3a28 28 0 0 1 7-5l4 5 12 6a19 19 0 0 1 8 7c4 7 10 11 17 14l33 14a46 46 0 0 0 5 2 16 16 0 0 0 2 2c4 2 4 5 0 8a16 16 0 0 1-15 1l-22-7a16 16 0 0 0 2 3 156 156 0 0 0 20 14c3 2 6 4 10 3a2 2 0 0 0 2 1l3 1-1 6c0 4 1 5 4 4l3 1c1 2 2 4 1 6s-3 2-5 2a13 13 0 0 1-6-2 16 16 0 0 0-4-1Z"
      />
      <path
        fill="var(--pants)"
        d="M302 211a28 28 0 0 0-7 5v3c2 2 1 3 0 5-3 6-8 9-13 13l-3 2a52 52 0 0 1-12 5c-3 1-5 0-7-3-3-8-9-13-17-16-10-4-17-11-19-22l1-8 20-9c6-3 12-3 17-2 4 1 5-1 5-3a46 46 0 0 0 4 1c2 0 4 1 5 3 1 5 5 7 9 9a145 145 0 0 1 17 15v2Z"
      />
      <path
        fill="var(--hair)"
        d="M375 301a16 16 0 0 1 4 1 13 13 0 0 0 6 2c2 0 4 0 5-2s0-4-1-6c0-2-2-1-2-1-4 1-5 0-5-4l1-6 2-1c5 2 11 1 17-1 6-1 12-4 17-7 3-2 6-3 9-1s2 5 1 8c-3 12-10 20-22 24l-12 4c-9 3-16-2-20-8a2 2 0 0 1 0-2ZM380 284a2 2 0 0 1-2-1l-12-13h2a16 16 0 0 0 15-1c4-3 4-6 0-8a16 16 0 0 1-2-2l1-1c9 3 17 2 24-3l7-2c2 0 5 1 4 4-3 5-5 11-11 14l-26 13Z"
      />
      <path
        fill="var(--flesh)"
        d="M185 127c-2 3-2 3-1 7-3 1-5 0-8-1-5-2-9-1-13 1l-2-2c1-2-2-3-4-5l-8-5c-1-2 1-16-1-17-3-1 10-4 12-6a10 10 0 0 1 7-3c3 3 7 5 9 9 1 1 10 9 10 12 4 4 0 7-1 10Z"
      />
      <path
        fill="var(--hair)"
        d="m159 102 1-3a10 10 0 0 1 7-3 29 29 0 0 0 0-5c-1-3-3-4-5-2l-4 3c-6 4-12 7-17 13-2 4-3 11 0 14a40 40 0 0 0 20 13 4 4 0 0 0 0-4c-9-4-11-20-2-26Z"
      />
    </g>
  </g>
</g>
    {#if isPaused}
    <svg viewBox="-6 -5 36 36" width="100%" height="100%" xmlns="http://www.w3.org/2000/svg" fill-rule="evenodd" clip-rule="evenodd"><path d="M10 24h-6v-24h6v24zm10 0h-6v-24h6v24zm-11-23h-4v22h4v-22zm10 0h-4v22h4v-22z"/></svg>
    {/if} 
  </svg>